import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { SCREEN_NAME, IMPRESSION_ACTIONS, CLICK_ACTIONS } from "../constants";

const FLOW_TYPE_OFO_GPS_ON = "@@flow_id=ofo,<GPS:ON>";
const FLOW_TYPE_OFO_GPS_OFF = "@@flow_id=ofo,<GPS:OFF>";

export const impressionEditDetails = (
    cartId: number | string,
    gpsEnabled: boolean,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_EDIT_DETAILS,
        label: JSON.stringify(cartId),
        context: gpsEnabled ? FLOW_TYPE_OFO_GPS_ON : FLOW_TYPE_OFO_GPS_OFF,
    });
};

export const impressionAddDetails = (
    cartId: number | string,
    gpsEnabled: boolean,
    isWidgetPosBottom: boolean,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: isWidgetPosBottom
            ? IMPRESSION_ACTIONS.IMPRESSION_OFO_CHECKOUT_DETAILS
            : IMPRESSION_ACTIONS.IMPRESSION_ADD_DETAILS,
        label: JSON.stringify(cartId),
        context: gpsEnabled ? FLOW_TYPE_OFO_GPS_ON : FLOW_TYPE_OFO_GPS_OFF,
    });
};

export const clickEditDetails = (
    cartId: number | string,
    gpsEnabled: boolean,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_EDIT_DETAILS,
        label: JSON.stringify(cartId),
        context: gpsEnabled ? FLOW_TYPE_OFO_GPS_ON : FLOW_TYPE_OFO_GPS_OFF,
    });
};

export const clickAddDetails = (
    cartId: number | string,
    gpsEnabled: boolean,
    isWidgetPosBottom: boolean,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: isWidgetPosBottom ? CLICK_ACTIONS.CLICK_OFO_CHECKOUT_DETAILS : CLICK_ACTIONS.CLICK_ADD_DETAILS,
        label: JSON.stringify(cartId),
        context: gpsEnabled ? FLOW_TYPE_OFO_GPS_ON : FLOW_TYPE_OFO_GPS_OFF,
    });
};
